export default {
  // 备忘录
  memo: {
    createTiem: 'creation time',
    creater: 'creater',
    allMemo: 'all memo',
    myCreate: 'I created',
    shareMe: 'share to me',
    deleted: 'deleted',
    thoroughDel: 'completely delete',
    outShare: 'exit the shared',
    resumeMemo: 'restore the cheat',
    remind: 'remind',
    addMemo: 'add the new memo',
    editMemo: 'edit the cheat',
    areYouSure: 'are you sure you want to',
    term: 'memos',
    noData: "you haven't added the memo yet",
    nowAdd: 'write a memo now',
    share: 'share',
    cc: 'carbon copy',
    selectReminderTime: 'select a reminder time',
    RemindYourselfOnly: 'only remind yourself',
    selectRelationship: 'selecet the relationship',
    selectedAddress: 'please select at least one address',
    addressAlreadyExists: 'the address already exists',
    dataAlreadyAssociated: 'the data is associated',
    pleaseSelectAssociatedData: 'please select the associated data',
    reminderTimeCannotBeEmpty: 'remind time cannot be empty',
    time_error: 'remind the time not to be earlier than the current time',
    conten_empty: 'the content cannot be empty',
    apply: 'apply',
    seachValue: 'please search for content'
  }
}
